import { SvgIconProps } from "@mui/material";
import { Arrow } from "./Arrow";

export const ArrowIconLeft = ({ sx, ...rest }: SvgIconProps) => {
	return (
		<Arrow
			{...rest}
			sx={{ ...sx, transform: "scale(-1, 1)", transformOrigin: "center" }}
		/>
	);
};

